<div class="order-shipping-updates--container lum-modal">
  <div class="lum-modal__header flex justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large">{{ data.title }} </span>
    <div class="lum-modal__header-close">
      <button
        type="button"
        class="lum-button lum-button--secondary"
        mat-button
        (click)="onClose()"
      >
        <lum-ui-icon
          class="mr-2-5"
          icon="close-circle"
          color="#5563D6"
          width="23"
          height="23"
        ></lum-ui-icon>
        Close
      </button>
    </div>
  </div>
  <mat-dialog-content>
    <div class="mt-3 py-3" *ngIf="data.isSelectAllRows">
      Selected all {{ data.remainingSelectableCount }} orders. Upon getting order
      updates, a job will be created to pull updates for all selected orders.
    </div>
    <div class="order-shipping-updates--content mt-3 py-3">
      <ng-container *ngIf="salesOrders.length > 0; else empty">
        <h6 class="shippable">Orders ({{ salesOrders.length }})</h6>
        <table class="shippable table table-stripped">
          <thead>
            <tr>
              <th>Order Date</th>
              <th>Order ID</th>
              <th>Order #</th>
              <th class="text-right">Total</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let order of salesOrders; trackBy: trackById">
              <td>{{ order.orderDate | date: 'mediumDate' }}</td>
              <td>{{ order.orderId }}</td>
              <td>{{ order.orderNumber }}</td>
              <td class="text-right">{{ order.orderTotal | currency: '' }}</td>
              <td>
                <span
                  class="shipping text-info"
                  *ngIf="order.pullingStatus === pullingStatus.GETTING_UPDATES"
                >
                  Getting updates <i class="fas fa-spinner fa-spin"></i>
                </span>
                <span
                  class="shipping text-red-600"
                  *ngIf="order.pullingStatus === pullingStatus.FAILED"
                >
                  FAILED
                </span>
                <span
                  class="shipping text-green-700"
                  *ngIf="order.pullingStatus === pullingStatus.UPDATED"
                >
                  UPDATED
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </ng-container>
      <ng-template #empty>
        <div class="text-red-500">No selected orders.</div>
      </ng-template>
    </div>
    <div class="order-shipping-updates--content mt-3 py-3">
      <ng-container *ngIf="filteredSalesOrders.length > 0">
        <h6 class="non-shippable">
          The listed orders are unable to retrieve shipping updates due to:
        </h6>
        <table class="non-shippable table table-stripped">
          <thead>
            <tr>
              <th>Order Date</th>
              <th>Order ID</th>
              <th>Order #</th>
              <th class="text-right">Total</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let order of filteredSalesOrders; trackBy: trackById">
              <td>{{ order.orderDate | date: 'mediumDate' }}</td>
              <td>{{ order.orderId }}</td>
              <td>{{ order.orderNumber }}</td>
              <td class="text-right">{{ order.orderTotal | currency: '' }}</td>
              <td class="non-updatable-orders-error--message text-red-600">
                <span *ngIf="order.errors.isPosted">{{
                  orderPullUpdatesErrors.NOT_POSTED
                }}</span>
                <span *ngIf="order.errors.isShipstation">{{
                  orderPullUpdatesErrors.IS_SHIPSTATION
                }}</span>
                <span *ngIf="order.errors.isShipkeyOmsEnabled">{{
                  orderPullUpdatesErrors.IS_SHIPKEY_OMS_ENABLED
                }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </ng-container>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button
      type="button"
      class="lum-button lum-button--tertiary mr-2"
      mat-button
      (click)="onClose()"
    >
      Close
    </button>
    <button
      (click)="onGetOrderUpdates()"
      [disabled]="loading || salesOrders.length === 0"
      mat-button
      type="button"
      class="lum-button"
    >
      Get Order Updates
    </button>
  </mat-dialog-actions>
</div>
